import styled from 'styled-components';

const MultiSelectOverflowStyled = styled.div`
    position: relative;
    display: flex;
    flex: auto;
    flex-wrap: wrap;
    max-width: 100%;
    gap: 8px;
`;

export default MultiSelectOverflowStyled;